// Shared persistence for the active-format picker + text-pattern regex.
// Both /scan and /capture read/write the same localStorage keys so the
// operator's choice survives across pages; keeping the shape in one
// module means the two surfaces can't drift on validation.

import { isActiveFormat, type ActiveFormat } from '../types';
import { DEFAULT_TEXT_PATTERN } from './textPattern';

export const ACTIVE_FORMAT_STORAGE_KEY = 'petf:scan:active-format';
export const TEXT_PATTERN_STORAGE_KEY = 'petf:scan:text-pattern';

// Cap must match TextPatternInput's MAX_PATTERN_LENGTH — a pathological
// ReDoS pattern poked in by DevTools or a prior build shouldn't get a
// chance to run against per-frame OCR text.
export const MAX_STORED_PATTERN_LENGTH = 128;

export function readStoredActiveFormat(): ActiveFormat {
  try {
    const raw = localStorage.getItem(ACTIVE_FORMAT_STORAGE_KEY);
    return isActiveFormat(raw) ? raw : 'qr';
  } catch {
    return 'qr';
  }
}

export function writeStoredActiveFormat(value: ActiveFormat): void {
  try {
    localStorage.setItem(ACTIVE_FORMAT_STORAGE_KEY, value);
  } catch {
    /* private mode etc. */
  }
}

export function readStoredTextPattern(): string {
  try {
    const raw = localStorage.getItem(TEXT_PATTERN_STORAGE_KEY);
    if (typeof raw !== 'string' || raw.length === 0) return DEFAULT_TEXT_PATTERN;
    if (raw.length > MAX_STORED_PATTERN_LENGTH) return DEFAULT_TEXT_PATTERN;
    // eslint-disable-next-line no-new
    new RegExp(raw);
    return raw;
  } catch {
    return DEFAULT_TEXT_PATTERN;
  }
}

export function writeStoredTextPattern(value: string): void {
  try {
    localStorage.setItem(TEXT_PATTERN_STORAGE_KEY, value);
  } catch {
    /* private mode etc. */
  }
}
